<div class="toast-container" [@detailExpand]="toastActive$ ? 'active' : 'inactive'">
  <div class="message-container flex">
    <div class="w-50 m-t-6 center"><i class="material-icons {{iconClass}}">check</i></div>
    <div class="w-350 center">{{payload$?.message}}</div>
  </div>
</div>